import React from "react"
import {
  Col,
  Row,
  Button,
  Card,
  CardBody,
  CardTitle,
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Label,
  Form,
  FormGroup,
  Input,
  CardSubtitle,
} from "reactstrap"
import Select from "react-select"
import PropTypes from "prop-types"
import { withRouter } from "react-router-dom"

const OffCanvasModel = ({isRight, toggleRightCanvas}) => {
  return (
    <React.Fragment>
      Right offcanvas
      <Offcanvas isOpen={isRight} direction="end" toggle={toggleRightCanvas} style={{ width: "900px" }}>
        <OffcanvasHeader toggle={toggleRightCanvas} className="mb-12">
          Offcanvas Right
        </OffcanvasHeader>
        <OffcanvasBody >
          <Card >
            <CardBody>
              <div>
                <CardTitle>Shipping information</CardTitle>
                <CardSubtitle className="mb-3">
                  Fill all information below
                </CardSubtitle>
                <Form>
                  <FormGroup className="mb-4" row>
                    <Label
                      htmlFor="billing-name"
                      md="2"
                      className="col-form-label"
                    >
                      Name
                    </Label>
                    <Col md="10">
                      <Input
                        type="text"
                        className="form-control"
                        id="billing-name"
                        placeholder="Enter your name"
                      />
                    </Col>
                  </FormGroup>
                  <FormGroup className="mb-4" row>
                    <Label
                      htmlFor="billing-email-address"
                      md="2"
                      className="col-form-label"
                    >
                      Email Address
                    </Label>
                    <Col md="10">
                      <Input
                        type="email"
                        className="form-control"
                        id="billing-email-address"
                        placeholder="Enter your email"
                      />
                    </Col>
                  </FormGroup>
                  <FormGroup className="mb-4" row>
                    <Label
                      htmlFor="billing-phone"
                      md="2"
                      className="col-form-label"
                    >
                      Phone
                    </Label>
                    <Col md={10}>
                      <input
                        type="text"
                        className="form-control"
                        id="billing-phone"
                        placeholder="Enter your Phone no."
                      />
                    </Col>
                  </FormGroup>
                  <FormGroup className="mb-4" row>
                    <Label
                      htmlFor="billing-address"
                      md="2"
                      className="col-form-label"
                    >
                      Address
                    </Label>
                    <Col md="10">
                      <textarea
                        className="form-control"
                        id="billing-address"
                        rows="3"
                        placeholder="Enter full address"
                      />
                    </Col>
                  </FormGroup>

                  <FormGroup className="select2-container mb-4" row>
                    <Label md="2" className="col-form-label">
                      Country
                    </Label>
                    <Col md="10">
                      <select className="form-control select2" title="Country">
                        <option value="0">Select Country</option>
                      </select>
                    </Col>
                  </FormGroup>

                  <FormGroup className="select2-container mb-4" row>
                    <Label md="2" className="col-form-label">
                      States
                    </Label>
                    <Col md="10">
                       {/* <Select
                        value={selectedGroup}
                        onChange={s => {
                          handleSelectGroup(s)
                        }}
                        options={optionGroup}
                        placeholder="Select States"
                        classNamePrefix="select2-selection"
                      />  */}
                    </Col>
                  </FormGroup>
                  <FormGroup className="mb-0" row>
                    <Label
                      htmlFor="example-textarea"
                      md="2"
                      className="col-form-label"
                    >
                      Order Notes:
                    </Label>
                    <Col md="10">
                      <textarea
                        className="form-control"
                        id="example-textarea"
                        rows="3"
                        placeholder="Write some note.."
                      />
                    </Col>
                  </FormGroup>
                </Form>
              </div>
            </CardBody>
          </Card>
        </OffcanvasBody>
      </Offcanvas>
    </React.Fragment>
  )
}

OffCanvasModel.propTypes = {
  isRight: PropTypes.bool,
  toggleRightCanvas: PropTypes.func,
}

export default withRouter(OffCanvasModel)
